var _mask, _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_314_30445",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 14,
    height: 14,
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    y: 9,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10C15.7239 10 15.5 10.2239 15.5 10.5V15.5H10.5C10.2239 15.5 10 15.7239 10 16C10 16.2761 10.2239 16.5 10.5 16.5H15.5V21.5C15.5 21.7761 15.7239 22 16 22C16.2761 22 16.5 21.7761 16.5 21.5V16.5H21.5C21.7761 16.5 22 16.2761 22 16C22 15.7239 21.7761 15.5 21.5 15.5H16.5V10.5C16.5 10.2239 16.2761 10 16 10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10C15.7239 10 15.5 10.2239 15.5 10.5V15.5H10.5C10.2239 15.5 10 15.7239 10 16C10 16.2761 10.2239 16.5 10.5 16.5H15.5V21.5C15.5 21.7761 15.7239 22 16 22C16.2761 22 16.5 21.7761 16.5 21.5V16.5H21.5C21.7761 16.5 22 16.2761 22 16C22 15.7239 21.7761 15.5 21.5 15.5H16.5V10.5C16.5 10.2239 16.2761 10 16 10Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.5V15.75H15.75V15.5H15.5ZM15.5 16.5H15.75V16.25H15.5V16.5ZM16.5 16.5V16.25H16.25V16.5H16.5ZM16.5 15.5H16.25V15.75H16.5V15.5ZM15.75 10.5C15.75 10.3619 15.8619 10.25 16 10.25V9.75C15.5858 9.75 15.25 10.0858 15.25 10.5H15.75ZM15.75 15.5V10.5H15.25V15.5H15.75ZM10.5 15.75H15.5V15.25H10.5V15.75ZM10.25 16C10.25 15.8619 10.3619 15.75 10.5 15.75V15.25C10.0858 15.25 9.75 15.5858 9.75 16H10.25ZM10.5 16.25C10.3619 16.25 10.25 16.1381 10.25 16H9.75C9.75 16.4142 10.0858 16.75 10.5 16.75V16.25ZM15.5 16.25H10.5V16.75H15.5V16.25ZM15.75 21.5V16.5H15.25V21.5H15.75ZM16 21.75C15.8619 21.75 15.75 21.6381 15.75 21.5H15.25C15.25 21.9142 15.5858 22.25 16 22.25V21.75ZM16.25 21.5C16.25 21.6381 16.1381 21.75 16 21.75V22.25C16.4142 22.25 16.75 21.9142 16.75 21.5H16.25ZM16.25 16.5V21.5H16.75V16.5H16.25ZM21.5 16.25H16.5V16.75H21.5V16.25ZM21.75 16C21.75 16.1381 21.6381 16.25 21.5 16.25V16.75C21.9142 16.75 22.25 16.4142 22.25 16H21.75ZM21.5 15.75C21.6381 15.75 21.75 15.8619 21.75 16H22.25C22.25 15.5858 21.9142 15.25 21.5 15.25V15.75ZM16.5 15.75H21.5V15.25H16.5V15.75ZM16.25 10.5V15.5H16.75V10.5H16.25ZM16 10.25C16.1381 10.25 16.25 10.3619 16.25 10.5H16.75C16.75 10.0858 16.4142 9.75 16 9.75V10.25Z",
    fill: "white",
    fillOpacity: 0.2,
    mask: "url(#path-3-outside-1_314_30445)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 30.5,
    height: 30.5,
    rx: 15.25,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyPlus);
export default __webpack_public_path__ + "static/media/grey-plus.0a8c53b318c50d2be2ebfabdf50abd83.svg";
export { ForwardRef as ReactComponent };